import styled from 'styled-components';
import { CopyStandard } from '../../atoms/Copytext';
import CTA from '../../atoms/CTA';
import { CTAIconPosition } from '../../atoms/CTA/CTA.constants';
import SocialMeta from './partials/SocialMeta';
import { CopyStandardSkin } from '../../atoms/Copytext/CopytextSkins';
import { useIntl } from 'react-intl';

const ItemContainer = styled.div``;

const ImageContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
`;

const Title = styled.div`
  ${CopyStandardSkin};
  color: ${(props) => props.theme.color.primary800};
  margin-bottom: 5px;
`;

/**
 * @param {SocialItemProps} props
 * @returns {React.ReactElement} The rendered component
 */
const SocialItem = ({
  createdAt,
  url,
  text,
  type,
  title,
  image = null,
  className,
}) => {
  const intl = useIntl();

  const getSocialLinktext = () => {
    switch (type) {
      case 'TWITTER':
        return intl.formatMessage({
          id: 'socialStream.socialMediaLinkTwitter',
        });
      default:
        return intl.formatMessage({
          id: 'socialStream.socialMediaLink',
        });
    }
  };

  return (
    <ItemContainer className={className}>
      {image && (
        <ImageContainer>
          <img src={image} />
        </ImageContainer>
      )}
      <SocialMeta type={type} createdAt={createdAt} />
      <Title>{title}</Title>
      <CopyStandard>{text}</CopyStandard>
      <CTA
        skin="TERTIARY"
        target="_blank"
        icon="ARROW_ANIMATION"
        iconPos={CTAIconPosition.Before}
        href={url}
        text={getSocialLinktext()}
      />
    </ItemContainer>
  );
};

export default SocialItem;
